module.exports = __webpack_public_path__ + "static/media/Johan&Carma(104-crop).63ad76ef.jpg";